import { Controller } from '@hotwired/stimulus'
import $ from 'jquery'
import 'slick-carousel'

export default class extends Controller {
  static targets = ['carousel', 'input', 'image']

  connect() {
    this.initCarousel()
  }

  disconnect() {
    this.destroyCarousel()
  }

  teardown() {
    this.destroyCarousel()
  }

  select(event) {
    const selectedValue = event.currentTarget.dataset.name

    this.inputTarget.value = selectedValue
    this.imageTargets.forEach(element => element.classList.remove('selected'))
    event.currentTarget.classList.add('selected')
  }

  initCarousel() {
    const $carousel = $(this.carouselTarget)

    if ($carousel.hasClass('slick-initialized')) {
      $carousel.slick('unslick')
    }

    $carousel.slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
    })

    const current = this.inputTarget.value

    this.imageTargets.forEach(element => {
      if (element.dataset.name === current) {
        element.classList.add('selected')
      }
    })
  }

  destroyCarousel() {
    if (!this.hasCarouselTarget) {
      return
    }

    const $carousel = $(this.carouselTarget)

    if ($carousel.hasClass('slick-initialized')) {
      $carousel.slick('unslick')
    }
  }
}
